<template>
    <div id="app" @contextmenu="disableRightClick">
        <keep-alive>
            <router-view v-if="keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!keepAlive"></router-view>
    </div>
</template>
<script>
//首页引入base.scss
import 'ASSETS/scss/common/base.scss'

export default {
    provide () {    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
        return {
            reload: this.reload
        }
    },
    data () {
        return {
            isRouterAlive: false,
        }
    },
    computed: {
        keepAlive () {
            return this.$route.meta.keep
        }
    },
    created () {
    },
    methods: {
        reload () {
            this.isRouterAlive = false;            //先关闭，
            this.$nextTick(function () {
                this.isRouterAlive = true;         //再打开
            })
        },
        disableRightClick(event) {
            if(event.target.dataset.sign != "search")
                event.preventDefault(); // 阻止默认右键菜单的显示
        },
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
* {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: 0;
    padding: 0;
}
.loading_cover {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1000;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.6);
    .loading_icon {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100px;
        transform: translate(-50%, -50%);
    }
}
</style>
